import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import PaymentIcon from "../../../images/pay.png";
import PaymentIconActive from "../../../images/pay-active.png";
import ProfileIcon from "../../../images/profile-icon.png";
import ProfileIconActive from "../../../images/profile-icon-active.png";
import CreditIcon from "../../../images/pay (1).png";
import CreditIconActive from "../../../images/credit-icon-active.png";
import ShareIcon from "../../../images/share.png";
import ShareIconActive from "../../../images/share-active.png";
import ResetIcon from "../../../images/password.png";
import ResetIconActive from "../../../images/password-active.png";
import LogoutIcon from "../../../images/logout.png";
import LogoutIconActive from "../../../images/logout-active.png";
import Header from "../../../layout/DefaultLayout/Header";
import Avatar from "../../../images/img_avatar.png";
import { getUserDetails } from '../action/user.actions'
import ResetPassword from './resetPassword';
import Credits from './credits';
import UpdatePofile from './updatePofile';
import { logout } from '../action/user.actions'
import { fromValidate, history } from '../../../helpers'

class UesrProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: 'Profile'
        }
    }

    componentDidMount() {
        const { dispatch, user } = this.props;
        dispatch(getUserDetails(user.id))
    }

    onChangeMenu = (menu) => {
        this.setState({ menu: menu })
    }

    logout = (e) => {
        const { dispatch } = this.props;
        dispatch(logout())
        console.log("Logging out")
        history.push('/')
    }

    render() {
        const { user } = this.props;
        const { menu } = this.state;
        return (
            <div>
                <Header></Header>
                <div className='profile-container'>
                    <div className='profile-box'>
                        <div className="row">
                            <div className="col-sm-12 col-md-4 col-xs-12">
                                <div>
                                    <div className="profile-image">
                                        <img src={Avatar} className="team-member-image" alt="" />
                                    </div>
                                    <div className="name-txt">{user.first_name} {user.last_name}</div>

                                    <div className="button-container">
                                        <div>
                                            <div
                                                onClick={() => { this.onChangeMenu('Profile') }}
                                                className={`profile-left-opt-cont ${(menu == 'Profile') ? 'selected' : ''}`}>
                                                <img src={menu == 'Profile' ? ProfileIconActive : ProfileIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Profile</div>
                                            </div>

                                            <div
                                                onClick={() => { this.onChangeMenu('Payment') }}
                                                className={`profile-left-opt-cont ${(menu == 'Payment') ? 'selected' : ''}`}>
                                                <img src={menu == 'Payment' ? PaymentIconActive : PaymentIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Payment Option</div>
                                            </div>

                                            <div
                                                onClick={() => { this.onChangeMenu('Credits') }}
                                                className={`profile-left-opt-cont ${(menu == 'Credits') ? 'selected' : ''}`}>
                                                <img src={menu == 'Credits' ? CreditIconActive : CreditIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Credits</div>
                                            </div>
                                            <div
                                                onClick={() => { this.onChangeMenu('Refrer') }}
                                                className={`profile-left-opt-cont ${(menu == 'Refrer') ? 'selected' : ''}`}>
                                                <img src={menu == 'Refrer' ? ShareIconActive : ShareIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Refer friend</div>
                                            </div>
                                            <div
                                                onClick={() => { this.onChangeMenu('ResetPassword') }}
                                                className={`profile-left-opt-cont ${(menu == 'ResetPassword') ? 'selected' : ''}`}>
                                                <img src={menu == 'ResetPassword' ? ResetIconActive : ResetIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Reset Password</div>
                                            </div>
                                            <div
                                                onClick={() => { this.logout() }}
                                                className="profile-left-opt-cont logout-line">
                                                <img src={menu == 'ResetPassword' ? LogoutIconActive : LogoutIcon} className="profile-left-icon" alt="" />
                                                <div className="profile-left-opt-txt">Logout</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-12 col-md-8 col-xs-12 border-left-tab">
                                {
                                    menu == 'Profile' &&
                                    <UpdatePofile></UpdatePofile>
                                }
                                {
                                    menu == 'ResetPassword' &&
                                    <ResetPassword></ResetPassword>
                                }
                                {
                                    menu == 'Credits' &&
                                    <Credits></Credits>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
    }
}
export default connect(mapStateToProps)(UesrProfile);